import React, { Component } from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { hideModal, MODAL_QUESTION_MULTY_FORM } from '../../../../modules/modals';
import FormContent from './components/FormContent';

export class QuestionModal extends Component {
  static contextTypes = {formatMessage: PropTypes.any};
  constructor(props) {
    super(props)
    this.state = {
      spinner: true,
      modal: false,
    }
  }
  handleClose = () => {
    this.setState({modal: false})
    const { hideModal } = this.props;
    hideModal({ modalType : MODAL_QUESTION_MULTY_FORM});
    document.body.classList.remove('ReactModal__Body--open');
  }

  handleClose2 = () => {
    this.setState({
      modal: true
    })
  }

  getTitle = () => {
    const {formatMessage} = this.context
    let text = "frmTitleAddNewQuestion"
    return <div className="create-dialog-modal-content__title">{formatMessage(text)}</div>;
  }

  render() {
    const { zIndex, initialValues } = this.props;
    const {formatMessage} = this.context;
    const { modal } = this.state;

    return <React.Fragment>
      <Modal
        isOpen = {modal}
        style = {{
            overlay : {zIndex: 9999999},
        }}
        onRequestClose={() => {}}
        overlayClassName = "custom-modal"
        className = "custom-modal-content create-dialog-modal-content"
      >
        <div className="create-dialog-modal-content__header">
          <div className="create-dialog-modal-content__title">{formatMessage('msgTextCloseQuestionModal')}</div>
        </div>
        <div className="create-dialog-modal-content__body">
          <div className="create-dialog-form form-quiz-create">
            <div className="col-xs-12 text-center word-wrap-break" style={{marginBottom: 10}}>{formatMessage('msgTextQuestionModal')}</div>
            <div className="create-dialog-form__group flex">
              <button className="btn btn-primary" type="button" onClick={this.handleClose}>{formatMessage('Yes')}</button>
              <button className="btn btn-warning" type="button" onClick={() => this.setState({modal: false})}>{formatMessage('No')}</button>
            </div>
          </div>
          
        </div>
      </Modal>
      <Modal
        isOpen = {true}
        style = {{
            overlay : {zIndex: 999999},
        }}
        onRequestClose={this.handleClose2}
        overlayClassName = "custom-modal"
        className = "custom-modal-content create-dialog-modal-content ModalFormQbm ModalFormQuestion"
      >
        <div className="create-dialog-modal-content__header">
            {
              this.getTitle()
            }
            <div
                onClick={this.handleClose2}
                className="create-dialog-modal-content__close"
            ></div>
        </div>
        <div className="create-dialog-modal-content__body">
          <FormContent initialValues={initialValues} handleClose={this.handleClose} handleClose2={this.handleClose2}  />
        </div>
      </Modal>;
    </React.Fragment>
  }
}

const mapStateToProps = (state, ownProps) => ({
  
})

const mapDispatchToProps = {
  hideModal,
}

export default connect(mapStateToProps, mapDispatchToProps)(QuestionModal)



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Question/components/QuestionModal/QuestionModal.jsx